import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { instagramAdsSetup } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, IInstagramAdCreateDTO } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


export const addinstagramAds = createAsyncThunk<
  any,
  IInstagramAdCreateDTO,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addinstagramAds"),
  async (payload, { rejectWithValue }) => {
    try {
      const response = await instagramAdsSetup.createinstagramAds(payload);

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

    //   console.log("🔥 FIXED RESPONSE:", response);

      const { httpStatusCode, data, message } = response;

	  //@ts-ignore
      if (httpStatusCode === 200 && data?.isSuccess === true) {
        const adId = data?.responseBody?.data?.id;

        return {
          data: {
            id: adId,
          },
          message: "Ad created successfully",
        };
      }

      return rejectWithValue({
        httpStatusCode,
        message: data?.responseBody?.error?.message || message,
		//@ts-ignore
		responseBody: response.data 
      });

    } catch (error) {

      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);



export const getinstagramAdsList = createAsyncThunk<
	iGenericResponse<any | null> | null,
	void,
	{
		rejectValue: iStateMessage;
	}
>(
	curriedGetThunkName("getinstagramAdsList"),
	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
	async (arg, { rejectWithValue }) => {
		try {
			const response = await instagramAdsSetup.getinstagramAds();
			if (response) {
				const { httpStatusCode, data, message } = response;

				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							return {
								data: {
									httpStatusCode,
									data: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message,
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: "No response received",
				});
			}
		} catch (error) {
			return rejectWithValue({
				message: "Something went wrong",
			});
		}
	},
);








